import Seo from "@/components/base/Seo";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import ProblemNav from "./components/ProblemNav";
import Solutions from "./components/Solutions";
import Tips from "./components/Tips";
import Faq from "./components/Faq";
import Reviews from "./components/Reviews";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/faqs";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "笔笔漫画网帮助中心",
    url: "https://manhua4.github.io/",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://manhua4.github.io/?s={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "笔笔漫画网",
    url: "https://manhua4.github.io/",
    description: "笔笔漫画网使用问题一站式帮助中心，解决打不开、加载慢、换源、收藏、搜索、登录等常见问题。",
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer support",
      email: "support@bibi-manga.help",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.question,
      acceptedAnswer: { "@type": "Answer", text: f.answer },
    })),
  },
];

export default function Home() {
  return (
    <>
      <Seo
        title="笔笔漫画网帮助中心 - 打不开/加载慢/换源/收藏/搜索/登录问题全解决"
        description="笔笔漫画网使用问题一站式解决：网页打不开、加载慢、换源失败、收藏丢失、搜索无结果、登录异常，按步骤操作即可恢复顺畅阅读，收藏搜索登录一步到位。"
        keywords="笔笔漫画网,笔笔漫画网打不开,笔笔漫画网加载慢,笔笔漫画网换源,笔笔漫画网收藏,笔笔漫画网搜索,笔笔漫画网登录"
        canonicalPath="/"
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        <Hero />
        <ProblemNav />
        <Solutions />
        <Tips />
        <Faq />
        <Reviews />

        <section className="mx-auto max-w-7xl px-4 pb-14 md:px-6 md:pb-20">
          <div className="relative overflow-hidden rounded-3xl bg-primary-500 px-6 py-12 text-center md:px-12 md:py-16">
            <div className="pointer-events-none absolute -right-6 -top-8 text-[10rem] text-white/10">
              <i className="ri-pen-nib-line" />
            </div>
            <div className="pointer-events-none absolute -bottom-8 -left-6 text-[10rem] text-white/10">
              <i className="ri-book-open-line" />
            </div>
            <h2 className="relative text-2xl font-black text-background-50 md:text-3xl">
              还有问题没解决？
            </h2>
            <p className="relative mx-auto mt-3 max-w-xl text-sm leading-7 text-primary-100 md:text-base">
              上面的分类和步骤覆盖了大部分使用问题。如果还是搞不定，欢迎通过联系方式向我们反馈，
              或先看看「关于我们」了解这个帮助中心。
            </p>
            <div className="relative mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Link
                to="/contact"
                className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-bold text-primary-700 transition-colors hover:bg-secondary-100 sm:w-auto"
              >
                <i className="ri-send-plane-line" />
                去反馈问题
              </Link>
              <Link
                to="/about"
                className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-white/40 px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-white/10 sm:w-auto"
              >
                <i className="ri-team-line" />
                了解我们
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}